import { Button } from 'react-aria-components'
import { useSelector, useDispatch } from 'react-redux'
import { selectIsNoDelay, selectFreePlayTimeOfDay, selectFreePlayTimeSlotConsumed, selectFreePlayHasAdvancedOnce, advanceFreePlayTimeOfDay } from '../settingsSlice.js'

const TIME_OF_DAY_ICONS = { morning: '☀️', afternoon: '🌤️', evening: '🌇', night: '🌙' }

// Free play has no wall clock, so the player advances time-of-day manually.
// Only rendered in free play, and hidden only during the very first Scientific
// Detective scene: before that scene is finished (freePlayTimeSlotConsumed)
// and before the player has ever advanced (freePlayHasAdvancedOnce), there's
// nothing else to do yet. Once either is true, it stays visible for the rest
// of the session — freePlayHasAdvancedOnce never resets, so it keeps the
// widget up across the per-slot consumed/reset cycle from then on.
export default function FreePlayTimeOfDay () {
  const isFreePlay = useSelector(selectIsNoDelay)
  const timeOfDay = useSelector(selectFreePlayTimeOfDay)
  const isSlotConsumed = useSelector(selectFreePlayTimeSlotConsumed)
  const hasAdvancedOnce = useSelector(selectFreePlayHasAdvancedOnce)
  const dispatch = useDispatch()

  if (!isFreePlay || (!isSlotConsumed && !hasAdvancedOnce)) return null

  return (
    <Button
      onPress={() => dispatch(advanceFreePlayTimeOfDay())}
      aria-label={`Current time of day: ${timeOfDay}. Tap to advance to the next time of day.`}
      className='fixed bottom-4 right-4 z-[9999] flex flex-col items-center gap-0.5 px-3 py-2 bg-white border-2 border-solid border-black rounded-xl shadow-lg font-mono hover:bg-gray-100'
    >
      <span className='flex items-center gap-1.5 text-sm capitalize'>
        <span>{TIME_OF_DAY_ICONS[timeOfDay]}</span>
        <span>{timeOfDay}</span>
        <span aria-hidden='true' className='text-base leading-none'>⟳</span>
      </span>
      <span className='text-[10px] leading-none text-gray-500'>tap to advance time</span>
    </Button>
  )
}
